import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark text-gray-500 py-10 px-4 border-t border-brand-accent/20" data-id="element-102">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-103">
        <div className="inline-block bg-brand-accent text-white font-bold px-3 py-1 rounded-full mb-4 text-xs tracking-wider" data-id="element-104">
          🌾 KIT PROFE™
        </div>

        <p className="text-base md:text-lg font-medium mb-3 max-w-xl text-gray-300" data-id="element-105">
          El sistema de materiales N°1 para docentes de escuelas técnicas y
          rurales
        </p>

        <p className="mt-6 text-brand-accent font-bold text-sm md:text-base neon-glow" data-id="element-106">
          👉 Porque enseñar economía en el campo no debería costarte todos los
          domingos
        </p>
      </div>
    </footer>;
}